/* eslint-disable @typescript-eslint/ban-ts-comment */
import "swiper/css";
import "swiper/css/pagination";

import { useState } from "react";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperClass, SwiperSlide } from "swiper/react";

import { ArrowButton } from "@/components/Buttons/ArrowButton";
import theme from "@/styles/themes/theme";
import { Box, Stack, useMediaQuery } from "@mui/material";

import { styles } from "./styles";
import { FootballPartnerCarouselProps } from "./types";
import { FootballPartnerCard } from "./FootballPartnerCard";

export const FootballPartnerCarousel: React.FC<FootballPartnerCarouselProps> = ({
  carouselName,
  paginationBullet,
  paginationBulletActive,
  items,
  defaultShield
}) => {
  const [swiperRef, setSwiperRef] = useState<SwiperClass | null>(null);
  const isMd = useMediaQuery(theme.breakpoints.up("sm"));
  const [areButtonsHidden, setAreButtonsHidden] = useState(false);

  if (!items?.length) {
    return null;
  }

  const handleNext = () => {
    if (!swiperRef) {
      return;
    }

    swiperRef.slideNext();
  };

  const handleBack = () => {
    if (!swiperRef) {
      return;
    }

    swiperRef.slidePrev();
  };

  const onChange = () => {
    const prevDisabled = document.getElementById(`${carouselName}-back-button`)?.classList?.contains("disable-navigation") as boolean;
    const nextDisabled = document.getElementById(`${carouselName}-next-button`)?.classList?.contains("disable-navigation") as boolean;

    setAreButtonsHidden(nextDisabled && prevDisabled);
  };

  return (
    <Stack px={{ xs: 3, md: 4, lg: 10 }} pr={{ xs: 0, sm: 0 }} sx={{ height: "100%", width: "100%" }}>
      <Box css={styles.container({ paginationBullet, paginationBulletActive })} maxWidth="100vw" className="swiper-container">
        <Swiper
          onSwiper={setSwiperRef}
          pagination={
            isMd
              ? false
              : {
                  clickable: true
                }
          }
          modules={[Pagination, Navigation]}
          slidesPerView="auto"
          onSlideChange={onChange}
          updateOnWindowResize={true}
          centerInsufficientSlides={true}
          spaceBetween="24px"
          onResize={onChange}
          navigation={{
            enabled: true,
            nextEl: `#${carouselName}-next-button`,
            prevEl: `#${carouselName}-back-button`,
            lockClass: "disable-navigation"
          }}
        >
          {items.map((card, index) => (
            <SwiperSlide
              key={index}
              style={{
                height: "auto",
                minWidth: isMd ? "282px" : "73vw"
              }}
            >
              <FootballPartnerCard {...card} defaultShield={defaultShield} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>

      <Box css={styles.navigation_container} display={areButtonsHidden ? "none" : "inherit"} width="100%" justifyContent="center">
        <ArrowButton
          handleNext={handleNext}
          handleBack={handleBack}
          style={{ width: 52, height: 52, marginTop: "20px" }}
          backNavigationSelector={`${carouselName}-back-button`}
          nextNavigationSelector={`${carouselName}-next-button`}
        />
      </Box>
    </Stack>
  );
};
